var exports = {
  "jL": "pullRequestsDropdown__SZX5tD",
  "Rq": "pullRequestCountText__iuACbh",
  "Do": "loadingSpinnerContainer__9NtPLg",
  "bC": "linkedPullRequestsBtn__158v6Z",
};

module.exports = exports;
